import { Environment } from "types/enums/environment";

export const isEnvironment = (env: Environment) => process.env.NEXT_PUBLIC_DEPLOYED_ENV === (env as unknown as string);
